const randomNumber = (length) => Math.floor(Math.random() * length);
export default randomNumber;
